//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/電柱ポップアップ
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import '@esri/calcite-components/dist/components/calcite-action';
import '@esri/calcite-components/dist/components/calcite-list';
import '@esri/calcite-components/dist/components/calcite-list-item';
import {
  CalciteAction,
  CalciteList,
  CalciteListItem,
} from '@esri/calcite-components-react'

// 定数
const LOGH = 'BFA10103G pole popup:';

/**
 * 電柱ポップアップ/設備一覧
 */
export function PopupSetubiList({
  pole,
  setubiMap,
  setubiList,
  onSetubiEdit,
  onSetubiDelete,
}) {

  // 設備なしの場合
  if (setubiList.length === 0) {
    return <SetubiListNone />;
  }

  // 設備一覧描画
  let index = 0;
  return (
    <CalciteList scale="s"
      style={{
        marginTop: '8px',
        marginLeft: '1px',
        marginRight: '1px',
        border: 'solid 1px #DEDEDE'
      }}
    >
    {
      setubiList.map((setubi) => (
        <SetubiListItem
          key={'setubi-' + index++}
          setubi={setubi}
          setubiMap={setubiMap}
          onSetubiEdit={onSetubiEdit}
          onSetubiDelete={onSetubiDelete}
        />
      ))
    }
    </CalciteList>
  );
}

// プロパティ
PopupSetubiList.propTypes = {
  pole:       PropTypes.object,               // 電柱情報
  setubiList: PropTypes.array.isRequired,     // 架設設備一覧
  setubiMap:  PropTypes.instanceOf(Map),      // 架設設備マップ

  // イベントハンドラー
  onSetubiEdit:   PropTypes.func.isRequired,     // 設備編集
  onSetubiDelete: PropTypes.func.isRequired,     // 設備削除
};

// デフォルトエクスポート
export default PopupSetubiList;

/**
 * 電柱ポップアップ/設備一覧項目
 */
function SetubiListItem({
  setubi,
  setubiMap,
  onSetubiEdit,
  onSetubiDelete,
}) {

  // 項目選択処理 - 設備編集
  const handleItemSelect = React.useCallback(() => {
    console.log(LOGH, '設備編集', setubi);
    onSetubiEdit(setubi);
  }, [setubi, onSetubiEdit]);

  // 削除ボタン処理 - 設備削除
  const handleItemDelete = React.useCallback((e) => {
    console.log(LOGH, '設備削除', setubi);
    onSetubiDelete(setubi);
  }, [setubi, onSetubiDelete]);

  // 表示文字列
  const bukkenNo = `物件${setubi.bukkenNo}`;
  const setubiName = setubi.setubiCode
      ? setubiMap.get(setubi.setubiCode)
      : '架設設備未設定';

  // リスト項目描画
  return (
    <CalciteListItem
      label={bukkenNo + ' - ' + setubiName}
      onCalciteListItemSelect={handleItemSelect}
      style={{
        '--calcite-spacing-xxs': 0,  // 上下空白を狭くする
      }}
    >
      {/* 削除ボタン */}
      <CalciteAction
        icon="trash"
        slot="actions-end"
        onClick={handleItemDelete}
      />
    </CalciteListItem>
  );
}

// プロパティ
SetubiListItem.propTypes = {
  setubi:    PropTypes.object.isRequired,    // 架設設備情報
  setubiMap: PropTypes.instanceOf(Map),      // 架設設備マップ

  // イベントハンドラー
  onSetubiEdit:   PropTypes.func.isRequired,     // 設備編集
  onSetubiDelete: PropTypes.func.isRequired,     // 設備削除
};

/**
 * 電柱ポップアップ/設備一覧なし
 */
function SetubiListNone() {
  return (
    <div style={{
      marginTop: '8px',
      padding: '2rem 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      border: 'solid 1px #DEDEDE',
      color: 'grey',
    }}>
      <div>設備が登録されていません。</div>
      <div>設備を追加してください。</div>
    </div>
  );
}
